import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Inline } from '@atlaskit/primitives/compiled';
import { EmojiPlaceholder } from '@atlaskit/emoji';
import { token } from '@atlaskit/tokens';

import { fg } from '@confluence/feature-gating';

const styles = cssMap({
	emojiPlaceholderBackground: {
		backgroundColor: token('color.skeleton'),
	},
	wrapperStyles: {
		paddingLeft: token('space.100'),
		paddingRight: token('space.150'),
		marginTop: token('space.negative.025'),
	},
	countSkeletonStyles: {
		width: '10px',
		height: '10px',
		borderRadius: token('border.radius.circle'),
	},
	countSkeletonLightBackground: {
		backgroundColor: token('color.skeleton'),
	},
	countSkeletonDarkerBackground: {
		backgroundColor: token('color.background.neutral.subtle.pressed'),
	},
});

const PLACEHOLDER_COMMON_PROPS = {
	shortName: 'loading-placeholder',
	size: 16,
	xcss: styles.emojiPlaceholderBackground,
};

export const ReactionsSummaryViewPlaceholder = () => {
	return (
		<Inline space="space.050" alignBlock="center" css={styles.wrapperStyles}>
			<EmojiPlaceholder {...PLACEHOLDER_COMMON_PROPS} />
			<EmojiPlaceholder {...PLACEHOLDER_COMMON_PROPS} />
			<EmojiPlaceholder {...PLACEHOLDER_COMMON_PROPS} />
			<div
				css={[
					styles.countSkeletonStyles,
					fg('platform_reactions_placeholder_custom_background')
						? styles.countSkeletonLightBackground
						: styles.countSkeletonDarkerBackground,
				]}
				data-testid="reactions-summary-view-count-skeleton"
			/>
		</Inline>
	);
};
